import React, { useState } from 'react';
import ZardWith100Westers from '../../ZardWith100Westers.png';
import WizardHat3d from '../../3dWizardHat.png';

const Join = ({ setSignedIn, citizens, setIsAdmin, setUser }) => {
  const [citizenIDInput, setCitizenIDInput] = useState(
    localStorage.getItem('citizenID') != undefined
      ? localStorage.getItem('citizenID')
      : '',
  );
  const [errorMessage, setErrorMessage] = useState('');

  function onClickSignIn() {
    if (
      isCitizenIDValid(citizenIDInput, false, true) &&
      citizens != undefined
    ) {
      const citizensObjects = Object.values(citizens);
      var foundCitizenIDMatch = false;
      citizensObjects.forEach((citizenObject) => {
        if (citizenObject.citizenID == citizenIDInput) {
          foundCitizenIDMatch = true;
          setUser(citizenObject);
          setIsAdmin(citizenIDInput == process.env.REACT_APP_JONAH_CITIZEN_ID);
          localStorage.setItem('signedIn', 'true');
          localStorage.setItem('user', JSON.stringify(citizenObject));
          localStorage.setItem(
            'isAdmin',
            citizenIDInput == process.env.REACT_APP_JONAH_CITIZEN_ID,
          );
          setSignedIn(true);
        }
      });
      setErrorMessage(
        foundCitizenIDMatch
          ? ''
          : 'Citizen ID has a valid format, but found no matches. Try refreshing',
      );
    }
  }

  function isCitizenIDValid(citizenID, duringTyping, changeErrorMessage) {
    if (
      (citizenID.length == 1 && !citizenID.startsWith('C')) ||
      (citizenID.length == 2 && !citizenID.startsWith('CI')) ||
      (citizenID.length >= 3 && !citizenID.startsWith('CI-'))
    ) {
      if (citizenID.length < 7) {
        if (citizenID.length == 0) {
          if (changeErrorMessage)
            setErrorMessage(duringTyping ? '' : 'Enter Citizen ID to sign in');
          return duringTyping ? true : false;
        } else {
          if (changeErrorMessage)
            setErrorMessage("Invalid format. Citizen ID must begin with 'CI-'");
          return false;
        }
      } else {
        if (changeErrorMessage)
          setErrorMessage(
            "Invalid format. Citizen ID must begin with 'CI-' and be followed by 5 numbers",
          );
        return false;
      }
    } else {
      if (citizenID.length == 0) {
        if (changeErrorMessage)
          setErrorMessage(duringTyping ? '' : 'Enter Citizen ID to sign in');
        return duringTyping ? true : false;
      } else {
        if (citizenID.length < 7) {
          if (changeErrorMessage)
            setErrorMessage(
              duringTyping
                ? ''
                : "Invalid format. Citizen ID is too short. 5 numbers must follow 'CI-'",
            );
          return duringTyping ? true : false;
        } else {
          if (citizenID.length > 7) {
            if (changeErrorMessage)
              setErrorMessage(
                "Invalid format. Citizen ID is too dang long! At most 5 numbers must follow 'CI-'",
              );
            return false;
          } else {
            //console.log('checking if numbers', Number(citizenID.substring(3, 9)) !== NaN, Number(citizenID.substring(3, 9)))
            if (!Number(citizenID.substring(3, 7))) {
              if (changeErrorMessage)
                setErrorMessage("Invalid format. 5 numbers must follow 'CI-'");
              return false;
            } else {
              console.log('nu', Number(citizenID.substring(3, 7)));
              if (changeErrorMessage) setErrorMessage('');
              return true;
            }
          }
        }
      }
    }
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <div
      className='min-h-screen justify-center py-12'
      style={{
        backgroundImage: `url(${ZardWith100Westers})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div className='mx-6 lg:mx-0'>
        <div className='sm:mx-auto  sm:w-full sm:max-w-md '>
          <div className='flex justify-center bg-gray-200 py-8 px-4 shadow rounded-t-lg sm:px-10'>
            <div className='shadow bg-white border-l-2 border-b-2 border-blue-300 border-b-blue-200'>
              <a class='flex'>
                <img
                  className='w-12 h-12 p-1 border-t-2 border-gray-300'
                  src={WizardHat3d}
                ></img>
                <p className='text-3xl font-bold text-gray-700 p-1 border-r-2 border-t-2 border-gray-300 pr-2'>
                  Charlington Hub
                </p>
              </a>
            </div>
          </div>
        </div>

        <div className='sm:mx-auto  sm:w-full sm:max-w-md'>
          <div className='bg-sky-900 py-8 px-4 shadow rounded-b-lg sm:px-10'>
            <div className='w-full'>
              <p className='font-semibold text-center'>Citizen ID</p>
              <input
                placeholder='e.g. CI-4989, CI-2849...'
                value={citizenIDInput}
                onInput={(event) => {
                  setCitizenIDInput(event.target.value);
                  isCitizenIDValid(event.target.value, true, true);
                }}
                onKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    onClickSignIn();
                  }
                }}
                className={classNames(
                  isCitizenIDValid(citizenIDInput, true, false)
                    ? ''
                    : 'text-red-500 font-semibold',
                  'w-full type-password focus:outline-none border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 p-1 rounded',
                )}
              ></input>
              <div className='w-full flex justify-center py-6'>
                <button
                  className={classNames(
                    citizens != undefined &&
                      isCitizenIDValid(citizenIDInput, false, false)
                      ? 'bg-sky-400 text-gray-800 hover:bg-sky-500'
                      : 'bg-sky-200 text-gray-400',
                    'flex justify-center w-1/3 shadow font-semibold rounded-full px-3 py-2',
                  )}
                  onClick={onClickSignIn}
                >
                  SIGN IN
                </button>
              </div>
              {errorMessage && (
                <p className='text-center text-red-500 bg-white shadow p-1 font-semibold'>
                  {errorMessage}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Join);
